import { Member } from '@tribeplatform/gql-client/types'
import {
  useMemberActionItems,
  MemberContext,
} from '@tribeplatform/react-components/Member'
import { useRouter } from '@tribeplatform/react-sdk'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

type MemberActionItemsProps = {
  member: Member
  className?: string
  context?: MemberContext
}

export const MemberActionItems = ({
  member,
  className,
  context,
}: MemberActionItemsProps) => {
  const { Link } = useRouter()

  const { actions, children } = useMemberActionItems({ member, context })

  return (
    <>
      <Dropdown.Items className={className}>
        {actions.map(actionItem => {
          const Icon = actionItem.icon
          if (!actionItem) {
            return null
          }

          if (actionItem.action) {
            return (
              <Dropdown.Item
                key={actionItem.name}
                leadingIcon={<Icon />}
                onClick={actionItem.action}
                hotkey={actionItem?.hotkey}
              >
                {actionItem.name}
              </Dropdown.Item>
            )
          }

          return (
            <Dropdown.Item
              key={actionItem.name}
              as={Link}
              href={actionItem.url}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              variant="inherit"
              leadingIcon={<Icon />}
              hotkey={actionItem?.hotkey}
            >
              {actionItem.name}
            </Dropdown.Item>
          )
        })}
      </Dropdown.Items>
      {children}
    </>
  )
}
